import { Text } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveFeedbackSource } from 'app/modules/newTicketView/generalFeedback';
import { ViewerRole } from 'app/modules/newTicketView/types';
import './NewTicketViewCards.scss';

/** Roles allowed to see where a piece of general feedback came from. */
const ALLOWED_ROLES = [ViewerRole.Creator, ViewerRole.Admin];

interface IProps {
    /** The request being rendered (generated `RequestDto` or a list item). */
    selectedRequest?: unknown;
    /** Creator and admin only; a plain viewer never sees this card. */
    viewerRole?: ViewerRole;
    isVisible?: boolean;
}

/**
 * "Feedback source" card, rendered on General Feedback tickets only. Shows the
 * selected source and, when the source is "Other", the free-text detail.
 */
const FeedbackSourceCard = ({
    selectedRequest,
    viewerRole = ViewerRole.Viewer,
    isVisible = true
}: IProps) => {
    const { t: translate } = useTranslation();
    const feedbackSource = resolveFeedbackSource(selectedRequest);

    if (!isVisible || !feedbackSource || !ALLOWED_ROLES.includes(viewerRole)) {
        return null;
    }

    return (
        <div className="feedback-source-card" data-testid="feedback-source-card">
            <div className="fs-card-title">
                <Text>{translate('Feedback source')}</Text>
            </div>
            <div className="fs-card-question">
                <Text>{translate('Where did this feedback come from?')}</Text>
            </div>
            <div className="fs-card-value" data-testid="feedback-source-value">
                <Text>{feedbackSource.label}</Text>
            </div>
            {feedbackSource.details && (
                <div className="fs-card-details" data-testid="feedback-source-details">
                    <Text>{feedbackSource.details}</Text>
                </div>
            )}
        </div>
    );
};

export default FeedbackSourceCard;
